import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

import './styles.scss'

const Slider = ({ flow_tag }) => {
	const renderSwiperSlides = () => {
		switch (flow_tag) {
			case '33': {
				return (
					<>
						<SwiperSlide>
							<img src="/images/home/slider/slide1.png" alt="image0" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/slide2.png" alt="image1" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/slide3.png" alt="image2" />
						</SwiperSlide>
					</>
				)
			}
			case '55': {
				return (
					<>
						<SwiperSlide>
							<img src="/images/home/slider/orks/1.png" alt="image0" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/orks/2.png" alt="image1" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/orks/3.png" alt="image2" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/orks/4.png" alt="image2" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/orks/5.png" alt="image2" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/orks/6.png" alt="image2" />
						</SwiperSlide>
					</>
				)
			}
			default: {
				return (
					<>
						<SwiperSlide>
							<img src="/images/home/slider/image0-min.png" alt="image0" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/image1-min.png" alt="image1" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/image2-min.png" alt="image2" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/image3-min.png" alt="image3" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/image4-min.png" alt="image4" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/image5-min.png" alt="image5" />
						</SwiperSlide>
						<SwiperSlide>
							<img src="/images/home/slider/image6-min.png" alt="image6" />
						</SwiperSlide>
					</>
				)
			}
		}
	}

	return (
		<Swiper
			slidesPerView={2}
			spaceBetween={22}
			speed={1500}
			centeredSlides={true}
			loop={true}
			pagination={{
				clickable: true,
			}}
			autoplay={{
				delay: 2000,
				disableOnInteraction: false,
			}}
			className="slider"
		>
			{renderSwiperSlides()}
		</Swiper>
	)
}

export { Slider }
